/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesOfSolesDayFact } from '../../models/sales-of-soles-day-fact';

export interface DwhQueryControllerSalesOfSoles$Params {
  startYear: number;
  endYear: number;
}

export function dwhQueryControllerSalesOfSoles(http: HttpClient, rootUrl: string, params: DwhQueryControllerSalesOfSoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesOfSolesDayFact>>> {
  const rb = new RequestBuilder(rootUrl, dwhQueryControllerSalesOfSoles.PATH, 'get');
  if (params) {
    rb.query('startYear', params.startYear, {});
    rb.query('endYear', params.endYear, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesOfSolesDayFact>>;
    })
  );
}

dwhQueryControllerSalesOfSoles.PATH = '/api/dwh/query/sales-of-soles';
